export enum UserInterfaceState {
  Idle,
  Loading,
  Success,
  Error,
}

export namespace UserInterfaceState {
  export function isIdle(state: UserInterfaceState) {
    return state == UserInterfaceState.Idle;
  }
  export function isLoading(state: UserInterfaceState) {
    return state == UserInterfaceState.Loading;
  }
  export function isSuccess(state: UserInterfaceState) {
    return state == UserInterfaceState.Success;
  }
  export function isError(state: UserInterfaceState) {
    return state == UserInterfaceState.Error;
  }
}
